import { createSelector } from 'reselect'

const getLocalState = state => state.trackList || {}

export const getTrackListOffset = state => getLocalState(state).offset
export const getTrackListLimit = state => getLocalState(state).limit
export const getTrackListTotal = state => getLocalState(state).total
export const getMediaCount = state => getLocalState(state).media_count
export const getTrackListItems = state => getLocalState(state).items
export const getTrackListItemsByMediaNumber = createSelector(
	getTrackListItems,
	items => {
		const itemsByMediaNumber = []
		items.forEach(item => {
			if (typeof itemsByMediaNumber[item.media_number] === 'undefined') itemsByMediaNumber[item.media_number] = []
			itemsByMediaNumber[item.media_number].push(item)
		})
		return itemsByMediaNumber
	}
)



// WEBPACK FOOTER //
// ./src/components/tracklist/trackListSelectors.js